import React from 'react';
import { Link } from 'react-router-dom';

function CtaBanner() {
  return (
    <div className="cta reveal">
      <div className="cta-inner card">
        <h2>
          Have a project <span className="gradient-text">in mind?</span>
        </h2>
        <p>
          I'm available for freelance work and full-time roles. Let's build something
          great together.
        </p>
        <Link to="/contact" className="btn btn-primary">
          Get in touch <i className="fa-solid fa-arrow-right"></i>
        </Link>
      </div>
    </div>
  );
}

export default CtaBanner;
